<template>
    <footer class="card-footer has-background-primary">
        <a href="#" class="card-footer-item has-text-white" @click.prevent="submitButton">
            <span>Apply</span>
            <span class="icon">
                <i class="fas fa-search" aria-hidden="true"></i>
            </span>
        </a>
    </footer>
</template>

<script>
    export default {
        methods: {
            submitButton: function () {
                console.log(this.$store.getters.getQueryChassis)
                this.$store.dispatch('fetchResults')
            }
        }
    }
</script>

<style scoped>
    #submit {
        bottom: 5px;
        position: absolute;
        width: 80%;
        z-index: 1000;
    }
    .field {
        padding-top: 10px;

    }
    .control {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/Submit.vue